import { BasicTenant, Mutation } from 'graphql/generated/graphqlTypes';

export function mockedGoBackOneOnboardingStep(
  goBackOneOnboardingStep: BasicTenant
): Pick<Mutation, 'goBackOneOnboardingStep'> {
  return {
    goBackOneOnboardingStep
  };
}

export const mockedGoBackOneOnboardingStepDataForQuery = mockedGoBackOneOnboardingStep({
  __typename: 'BasicTenant',
  tenantId: 'mockedTenantId',
  name: 'mockedTenantName',
  onboardingStep: 'mockedPreviousCognitoOnboardingStep'
});
